import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Build: 2026-03-19-14:16 - PackageSelection COMPLETE REWRITE - Fixed all issues
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
